module.exports = __webpack_public_path__ + "media/red-tailed-hawk-3.7c09e343.mp3";